import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "@/lib/locales/en";
import it from "@/lib/locales/it";
import es from "@/lib/locales/es";

/**
 * Functional LAB — internationalisation orchestrator.
 *
 * • The three source-of-truth locales (English, Italian, Spanish) live in
 *   dedicated files under `./locales` and are imported above — they contain
 *   the full dictionary and require no per-key overrides here.
 * • The remaining five locales (PT / FR / ZH / JA / RU) still start from a
 *   shallow copy of English and override only the high-visibility keys below.
 *   Everything else falls back to English until a full professional pass is done.
 */

const dict = { en, it, es };

dict.pt = { ...dict.en };
dict.fr = { ...dict.en };
dict.zh = { ...dict.en };
dict.ja = { ...dict.en };
dict.ru = { ...dict.en };

// Every locale in `dict` is exposed to i18next under a `translation` namespace.
const resources = Object.fromEntries(Object.entries(dict).map(([k, v]) => [k, { translation: v }]));


export const LANGS = [
  { code: "en", label: "English",   flag: "🇬🇧" },
  { code: "it", label: "Italiano",  flag: "🇮🇹" },
  { code: "es", label: "Español",   flag: "🇪🇸" },
  { code: "pt", label: "Português", flag: "🇵🇹" },
  { code: "fr", label: "Français",  flag: "🇫🇷" },
  { code: "zh", label: "中文",       flag: "🇨🇳" },
  { code: "ja", label: "日本語",     flag: "🇯🇵" },
  { code: "ru", label: "Русский",   flag: "🇷🇺" },
];

const stored = (() => { try { return localStorage.getItem("fl_lang"); } catch { return null; } })();
i18n.use(initReactI18next).init({
  resources,
  lng: stored || (navigator?.language?.slice(0, 2)) || "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

i18n.on("languageChanged", (lng) => {
  try { localStorage.setItem("fl_lang", lng); } catch {}
  document.documentElement.setAttribute("lang", lng);
});
document.documentElement.setAttribute("lang", i18n.language);

export default i18n;
